import { render, staticRenderFns } from "./FooterLinksColumn.vue?vue&type=template&id=03fc0b69&scoped=true&"
import script from "./FooterLinksColumn.vue?vue&type=script&lang=ts&"
export * from "./FooterLinksColumn.vue?vue&type=script&lang=ts&"
import style0 from "./FooterLinksColumn.vue?vue&type=style&index=0&id=03fc0b69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fc0b69",
  null
  
)

export default component.exports